/* Native details provide the keyboard and no-script interaction. Preserve the
   exclusive group in older browsers and reveal a question selected in Shopify. */
(() => {
  if (window.CurvilaCactoxBuybox) return;
  const rootOf = node => node?.closest?.('[data-cc-product]');
  const isQuestion = node => node?.matches?.('details.cc-buy-question') && rootOf(node);
  function exclusive(question) {
    if (!isQuestion(question) || !question.open) return;
    rootOf(question).querySelectorAll('details.cc-buy-question[open]').forEach(other => {
      if (other !== question && other.name === question.name) other.open = false;
    });
  }
  function syncAnchors() {
    document.querySelectorAll('[data-cc-product] .cc-buy-questions[data-cc-anchor], [data-cc-product] .cc-buy-question[data-cc-anchor]').forEach(node => {
      const name = node.dataset.ccAnchor;
      if (!node.dataset.ccOriginalId) node.dataset.ccOriginalId = node.id;
      if (name && !document.getElementById(name)) node.id = name;
    });
  }
  function reveal(question) {
    if (!isQuestion(question)) return;
    question.open = true;
    exclusive(question);
  }
  function revealHash(hash) {
    let id;
    try { id = decodeURIComponent(hash.slice(1)); } catch { return; }
    if (id) reveal(document.getElementById(id));
  }
  document.addEventListener('toggle', event => exclusive(event.target), true);
  document.addEventListener('shopify:block:select', event => reveal(event.target.closest?.('details.cc-buy-question')));
  document.addEventListener('shopify:section:load', syncAnchors);
  document.addEventListener('shopify:section:unload', () => setTimeout(syncAnchors, 0));
  document.addEventListener('click', event => {
    const link = event.target.closest?.('.cc-buy-guarantee a[href^="#"]');
    if (link) revealHash(link.hash);
  });
  window.addEventListener('hashchange', () => revealHash(location.hash));
  const init = () => { syncAnchors(); revealHash(location.hash); };
  window.CurvilaCactoxBuybox = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
